import { MenuItem } from 'primereact/menuitem';
import React, { useLayoutEffect, useRef, useState } from 'react';

import { useMindmap } from '../../use-mindmap';
import { HistoryActions } from '../../use-mindmap-history';
import { getHistoryMenuModel } from './get-history-menu-model';

export interface HistoryMenuHookValue {
  type: 'node-history';
  actions: HistoryActions;
  undoHistoryMenuModel: MenuItem[];
  redoHistoryMenuModel: MenuItem[];
  onOpenDropdown: () => void;
}

export const historyMenuHook = (): HistoryMenuHookValue => {
  const {
    history: { actions, nodeMapChangeHistory, currentUndoRedoStep },
  } = useMindmap();
  const { redo, undo } = actions;
  const hoverState = useState<number>(-1);
  const setHoverIndex = hoverState[1];
  const dropdownMenuEndRef = useRef<HTMLAnchorElement>(null);

  const onUndoItemClick = (index: number) => undo(undoChangeHistory.length - index);

  const onRedoItemClick = (index: number) => redo(redoChangeHistory.length - index);

  // undo history is from currentUndoRedoStep to the last element
  const undoChangeHistory = nodeMapChangeHistory.slice(currentUndoRedoStep).reverse();
  const undoHistoryMenuModel: MenuItem[] = getHistoryMenuModel(
    undoChangeHistory,
    onUndoItemClick,
    hoverState,
    dropdownMenuEndRef,
  );

  // redo history is from currentUndoRedoStep to the first elment
  const redoChangeHistory = nodeMapChangeHistory.slice(0, currentUndoRedoStep);
  const redoHistoryMenuModel: MenuItem[] = getHistoryMenuModel(
    redoChangeHistory,
    onRedoItemClick,
    hoverState,
    dropdownMenuEndRef,
  );

  const scrollDropdownToBottom = () => dropdownMenuEndRef.current?.scrollIntoView({ block: 'nearest' });

  const onOpenDropdown = () => {
    setHoverIndex(-1);
    scrollDropdownToBottom();
  };

  // scroll dropdown to bottom on map changes
  useLayoutEffect(() => {
    scrollDropdownToBottom();
  }, [nodeMapChangeHistory]);

  return { type: 'node-history', actions, undoHistoryMenuModel, redoHistoryMenuModel, onOpenDropdown };
};

export const historyMenuTempHook = (): HistoryMenuHookValue => ({
  type: 'node-history',
  actions: {
    redo: () => {},
    undo: () => {},
    redoSelectable: false,
    undoSelectable: false,
  },
  undoHistoryMenuModel: [],
  redoHistoryMenuModel: [],
  onOpenDropdown: () => {},
});
